import React from 'react';
import './techlist.css';
import { fullName } from '../../utils/utils';
import { formatBackendShortDate, formatBackendTime } from '../../utils/date.utils';
import { ITechCheckItem } from '../../types/type';

function TechList({
  sortedAndSearchedPosts,
  onUserClick,
}: {
  sortedAndSearchedPosts: Array<Record<string, any>>;
  onUserClick: (id: string) => void;
}) {
  const data = sortedAndSearchedPosts as ITechCheckItem[];

  return (
    <React.Fragment>
      {data.map((item, index: number) => (
        <React.Fragment key={`techlist-${item.id}-${index}`}>
          <tr className="table-row__technik">
            <td className="technik__td">
              <div className="__patient">{fullName(item.profile)}</div>
              {/* <div>
                <span className={`statusDot ${item.checkStatus ? 'active' : 'no_active'}`}></span>
                <span className="title__gray"> {item.checkStatus ? 'Активен' : 'Не активен'}</span>
              </div> */}
              <div className="technik__td-autopark">
                <span className="title__gray">Автопарк</span> {item.autopark?.legalName}
              </div>
            </td>
            <td className={`technik__td __info1`}>
              <div>
                <span className="title__gray">Дата</span> {formatBackendShortDate(item.checkTime)}
              </div>
              <div>
                <span className="title__gray">Время</span> {formatBackendTime(item.checkTime)}
              </div>
            </td>
            <td className={`technik__td __info2`}>
              <div>
                <span className="title__gray">Гос.номер</span> {item.car.number}
              </div>
              <div>
                <span className="title__gray">Марка авто</span> {item.car.mark} {item.car.model}
              </div>
            </td>
            <td className={`technik__td __info3`}>
              <div>
                <span className="title__gray">Номер заявки</span> {item.num}
              </div>
              <div>
                <span className="title__gray">Заключение</span>{' '}
                {item.checkStatus === 'completed'
                  ? 'Допущен'
                  : item.checkStatus === 'rejected'
                    ? 'Не допущен'
                    : 'Ожидает'}
              </div>
            </td>
            <td className="user-action">
              <div className="show__button">
                <div className="link-button" onClick={() => onUserClick(item.id)}>
                  Смотреть
                </div>
                <svg
                  className="icon__eye"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.625 7.5C0.625 7.5 3.125 2.5 7.5 2.5C11.875 2.5 14.375 7.5 14.375 7.5C14.375 7.5 11.875 12.5 7.5 12.5C3.125 12.5 0.625 7.5 0.625 7.5Z"
                    stroke="#25282B"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.5 9.375C8.53553 9.375 9.375 8.53553 9.375 7.5C9.375 6.46447 8.53553 5.625 7.5 5.625C6.46447 5.625 5.625 6.46447 5.625 7.5C5.625 8.53553 6.46447 9.375 7.5 9.375Z"
                    stroke="#25282B"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div
                className={
                  'status__button ' +
                  (item.checkStatus === 'completed' || item.checkStatus === 'completed'
                    ? 'true'
                    : item.checkStatus === 'rejected'
                      ? 'false'
                      : 'waiting')
                }
              >
                {item.checkStatus === 'completed' || item.checkStatus === 'completed'
                  ? 'Допущен'
                  : item.checkStatus === 'rejected'
                    ? 'Не допущен'
                    : 'Ждет контроля'}
              </div>
            </td>
          </tr>
          <tr key={`${item.id}-divider-${index}`} className="admin-table__item-divider" />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

export default TechList;
